import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultError: {
    id: `app.containers.flashMessage.defaultError`,
    defaultMessage: 'Oops, something went wrong. Please try again.',
  },
  networkError: {
    id: 'app.containers.flashMessage.networkError',
    defaultMessage: 'Network error detected. Please try again.',
  },
});
